import { GetterTree } from 'vuex'
import { PreviewStateInterface } from '@/models/store/PreviewState.interface'
import { RootStateInterface } from '@/models/store/RootState.interface'

const getters: GetterTree<PreviewStateInterface, RootStateInterface> = {
  caseFileSlug(state: PreviewStateInterface) {
    if (state.targetType === 'case_file' && state.targetId) {
      return String(state.targetId).split(':')?.at(-1)
    }
  },
  // Driven by the response, so the card shown and the card rendered agree.
  isRichCard(state: PreviewStateInterface) {
    return state.richCards.length > 0
  }
}

export default getters
